import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    content: String,
    successMessage: String
  }

  copy(event) {
    event.preventDefault()

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.contentValue).then(() => {
        this.showSuccess()
      }).catch(err => {
        console.error('Failed to copy:', err)
        this.fallbackCopy()
      })
    } else {
      this.fallbackCopy()
    }
  }

  fallbackCopy() {
    const textarea = document.createElement('textarea')
    textarea.value = this.contentValue
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showSuccess()
      } else {
        this.showError()
      }
    } catch (err) {
      console.error('Fallback copy failed:', err)
      this.showError()
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showError() {
    const originalText = this.buttonTarget.textContent

    this.buttonTarget.textContent = '✗ Failed'
    this.buttonTarget.classList.add('bg-red-600')

    setTimeout(() => {
      this.buttonTarget.textContent = originalText
      this.buttonTarget.classList.remove('bg-red-600')
    }, 2000)
  }

  showSuccess() {
    const originalText = this.buttonTarget.textContent

    this.buttonTarget.textContent = this.successMessageValue || '✓ Copied!'
    this.buttonTarget.classList.add('bg-green-600')

    setTimeout(() => {
      this.buttonTarget.textContent = originalText
      this.buttonTarget.classList.remove('bg-green-600')
    }, 2000)
  }
}
